import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import * as L from 'leaflet';
import { Icon, icon } from 'leaflet';
import { AnonymizationService } from '../../services/anonymization.service';
// L.Icon.Default.imagePath = 'assets/leaflet/marker.png';
@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrl: './map.component.scss',
})
export class MapComponent implements OnInit, AfterViewInit {
  private map!: L.Map;
  @Input() lat = 48.8783389;
  @Input() lon = 2.3063031;
  @Input() address: any;
  @Input() missionStatus: string; // Add this input to receive mission status
  
  private defaultIcon: Icon = icon({
    iconUrl: 'assets/leaflet/marker.png',
    shadowUrl: 'assets/leaflet/marker-shadow.png',
    iconSize: [25, 30], // => random values you have to choose right ones for your case
    iconAnchor: [20, 51], // => random values too
  });
  markers: L.Marker[] = [
    L.marker([this.lat, this.lon], { icon: this.defaultIcon }), // Amman
  ];

  constructor(private anonymizationService: AnonymizationService) {}

  ngOnInit() {
    // Initialize markers array but don't add to map yet
    if (this.address) {
      this.markers = [
        L.marker([this.address.lat, this.address.lon], {
          icon: this.defaultIcon,
        }),
      ];
    }
  }

  ngAfterViewInit() {
    this.initializeMap();
    this.addLocationIndicator();
    this.centerMap();
  }

  private initializeMap() {
    const baseMapURl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
    this.map = L.map('map', {
      center: [this.address.lat, this.address.lon],
      zoom: 0,
      minZoom: 0,  // Définir explicitement le zoom minimum
      maxZoom: 19  // Définir explicitement le zoom maximum
    });
    L.tileLayer(baseMapURl).addTo(this.map);
  }

  private addLocationIndicator() {
    // Check if we should anonymize the location
    if (this.missionStatus && this.anonymizationService.shouldAnonymize(this.missionStatus)) {
      // Add a circle instead of a marker for anonymized locations
      const circle = L.circle([this.address.lat, this.address.lon], {
        color: 'red',
        fillColor: '#f03',
        fillOpacity: 0.2,
        radius: 100000 // 5000 meters radius
      }).addTo(this.map);
      
      // Force le zoom au minimum possible
      this.map.setZoom(7);
      // Désactiver temporairement les contrôles de zoom pour éviter que l'utilisateur ne zoome trop
      // this.map.scrollWheelZoom.disable();
      // this.map.touchZoom.disable();
      // this.map.zoomControl.remove();
    } else {
      // Add precise marker for non-anonymized locations
      this.markers.forEach((marker) => marker.addTo(this.map));
      
      // Réactiver les contrôles de zoom
      //this.map.scrollWheelZoom.enable();
      //this.map.touchZoom.enable();
    }
  }

  private centerMap() {
    // If anonymized, center on the circle
    if (this.missionStatus && this.anonymizationService.shouldAnonymize(this.missionStatus)) {
      this.map.setView([this.address.lat, this.address.lon], 7); // Slightly zoomed out
    } else {
      // Create a LatLngBounds object to encompass all the marker locations
      const bounds = L.latLngBounds(
        this.markers.map((marker) => marker.getLatLng())
      );

      // Fit the map view to the bounds
      this.map.fitBounds(bounds);
    }
  }
}
